import { COLORS } from '../../constants/layout';

// Recibe dark como argumento para aplicar el color según el theme
export const getLayoutRoot = (dark) => ({
  // Use full viewport height (via --vh) and let the inner container
  // handle header/footer spacing via padding. This keeps the root
  // height stable even on small screens.
  minHeight: '100vh',
  backgroundColor: dark ? COLORS.bgContainerDark : COLORS.bgContainer,
});

const layoutContainer = {
  // Reserve space for fixed header and footer using padding so the
  // inner container can scroll independently if needed.
  // Padding handled in index.css for responsiveness
  // paddingTop: NAVBAR_HEIGHT + PADDING_CONTAINER,
  // paddingBottom: FOOTER_HEIGHT + PADDING_CONTAINER,
  // Make the container a flex column so children can stretch to fill
  display: 'flex',
  flexDirection: 'column',
  flex: 1, // Ensure it takes available space
  // justifyContent: 'center',
  // alignItems: 'center',
  // height: '100vh', 
  // justifyContent: 'flex-center',
  // alignItems: 'center',

  // Allow container to grow and scroll when content overflows
  // flex: '1 1 auto',
  // overflow: 'auto',
};

const classLayoutRoot = 'd-flex flex-column ';
const classNavTitle = 'fw-bold text-primary';

export const styles = {
  layoutContainer,
  classLayoutRoot,
  classNavTitle,
};